import { useState } from "react";
import { ReactComponent as Loader } from "../assets/loader.svg";

const ActionButton = ({ icon, className, id, tooltip, link, onClick }) => {
  const [isLoading, setIsLoading] = useState(false);

  const wrappedOnClick = () => {
    setIsLoading(true);
    onClick().finally(() => {
      setIsLoading(false);
    });
  };
  return (
    <div>
      {link && (
        <a
          data-tip={tooltip}
          data-for={id}
          className={`sby-action-btn ${className ?? ""}`}
          href={link}
        >
          {icon}
        </a>
      )}
      {!link && (
        <button
          data-tip={tooltip}
          data-for={id}
          className={`sby-action-btn ${isLoading ? "loading" : "false"} ${
            className ?? ""
          }`}
          onClick={wrappedOnClick}
        >
          {!isLoading && icon}
          {isLoading && <Loader />}
        </button>
      )}
    </div>
  );
};

export default ActionButton;
